<template>
    <div class="home">
      <music></music>
      <!-- 测试时注释掉 -->
      <loading ref="loading" :progress="loadProgress"></loading>
      <flying ref="flying" @hide="flyingHide"></flying>
      <!-- 分享蒙版 -->
      <transition name="fade">
        <div class="home__share" @click="hideShare" v-show="showShare">
          <img src="http://cdn.shikehuyu.com/yfjs/public/share.png" class="home__share__img">
        </div>
      </transition>
      <transition name="fade">
        <div class="home__btn" @touchstart="play(true)" @touchend="stop(false)" v-show="showBtn">
          <div class="home__btn__img pulse" :class="{ show: showBtnImg }"></div>
        </div>
      </transition>
    </div>
</template>

<script>
import Music from '@/components/music'
import Loading from '@/components/loading'
import Flying from '@/components/Flying'

import LongTake from '@/LongTake'

import config from '@/assets/config'
import musicTimes from '@/assets/musicTimes'
import resource from '@/assets/resource'
import sprites from '@/assets/sprites'
import spritesAnimations from '@/assets/spritesAnimations'
import texts from '@/assets/texts'
import textsAnimations from '@/assets/textsAnimations'

export default {
  name: 'home',

  components: { Music, Loading, Flying },

  data () {
    return {
      loadProgress: 0,
      showShare: false,
      current: 0,
      speed: 0.0001,
      showBtnImg: true,
      showBtn: false,
      minLoadTime: 3000
    }
  },

  methods: {
    init () {
      this.longTake = new LongTake({
        totalHeight: config.totalScrollW, // 总宽度
        container: this.$el, // DOM容器
        resource, // 加载的资源
        touchOptions: {
          touch: '.home', // 反馈触摸的dom
          initialValue: 0, // 起始位置
          factor: 0.5,
          moveFactor: 0.5,
          sensitivity: 0.8, // 不必需,触摸区域的灵敏度，默认值为1，可以为负数
          maxSpeed: 0.5 // 不必需，触摸反馈的最大速度限制
        },
        sprites, // 精灵图
        spritesAnimations, // 精灵动画
        texts, // 文本
        textsAnimations // 文本动画
      })
      this.longTake.on('loadProgress', (progress) => {
        this.loadProgress = progress
        // console.log(`加载进度: ${progress}`)
      })
      this.longTake.on('loadDone', () => {
        this.loaded = true
        if (Date.now() - this.tmp >= this.minLoadTime) this.loadDone()
      })
      this.longTake.on('progress', (progress) => {
        Object.keys(musicTimes).forEach((music) => {
          const time = musicTimes[music]
          if (Math.abs(progress - time) < 0.005 && !this.$bus.audios[music].playing()) {
            this.$bus.playMusic(music)
          }
        })
        // console.log(`当前进度: ${progress}`)
      })

      // 微信加载完毕事件
      document.addEventListener('WeixinJSBridgeReady', () => {
        if (!this.playedMusic && this.$bus.musicOn) {
          this.$bus.loadMusic()
          this.$bus.playMusic('bg')
          this.playedMusic = true
        }
      })
      // 防止无法播放
      document.body.addEventListener('touchstart', () => {
        if (!this.playedMusic && this.$bus.musicOn) {
          this.$bus.loadMusic()
          this.$bus.playMusic('bg')
          this.playedMusic = true
        }
      })

      this.tmp = Date.now()
      setTimeout(() => {
        if (this.loaded) this.loadDone()
      }, this.minLoadTime)
    },

    loadDone () {
      console.log('加载完毕')
      // 测试时注释掉
      this.$refs.loading.hide()
      this.$refs.flying.hide()
      // 用于测试
      // this.openingEnd()
    },

    flyingHide () {
      this.longTake.app.view.addEventListener('animationEnd', this.openingEnd)
      this.longTake.app.view.addEventListener('webkitAnimationEnd', this.openingEnd)
      this.longTake.app.view.className += ' opening'
    },

    openingEnd () {
      console.log('可以开始操作')
      // this.test()
      // this.longTake.initTouch()
      this.showBtn = true
      // 绑定点击事件
      this.addEvent()
      // 用于测试
      // const location = -3000 - 1165 - 3000 - 3000 - 3000 - 3000 - 5000 - 3000
      // this.moveTo(location)
    },

    addEvent () {
      this.longTake.sprites.s8_btnagain.interactive = true
      this.longTake.sprites.s8_btnagain.on('tap', () => {
        console.log('again')
        this.again()
      })
      this.longTake.sprites.s8_btnshare.interactive = true
      this.longTake.sprites.s8_btnshare.on('tap', () => {
        console.log('share')
        this.share()
      })
    },

    again () {
      this.showBtnImg = true
      this.showBtn = true
      this.current = 0
      this.$bus.playedMusic = []
      this.moveTo()
    },

    share () {
      this.showShare = true
    },

    hideShare () {
      this.showShare = false
    },

    moveTo (location = 0, duration = 0) {
      // this.longTake.alloyTouch.to(location, duration)
      this.longTake.touchmove(location)
    },

    test () {
      this.testProgress = 0
      this.testInterval = setInterval(() => {
        this.testProgress += 0.001
        this.longTake.timeline.seek(this.testProgress)
        this.longTake.trigger('progress', this.testProgress)
        if (this.testProgress >= 1) clearInterval(this.testInterval)
      }, 10)
    },

    play (check) {
      let canPlay = true
      if (check && this.playTimeout) {
        canPlay = false
      }
      if (canPlay) {
        this.playTimeout = setTimeout(() => {
          const tmp = Date.now()
          const d = this.lastTmp ? (tmp - this.lastTmp) : 10
          this.lastTmp = tmp
          if (this.current > config.scenesScrollD[1] * 0.9 && this.current < config.scenesScrollD[1] + config.scenesScrollT[1] * 0.4) { // 场景二内减速
            this.speedChangeTo(0.000035)
          } else if (this.current > config.scenesScrollD[2] && this.current < config.scenesScrollD[3]) { // 场景三内减速
            this.speedChangeTo(0.00007)
          } else if (this.current > config.scenesScrollD[4] * 0.95 && this.current < config.scenesScrollD[5]) { // 场景四内减速
            this.speedChangeTo(0.00006)
          } else if (this.current > config.scenesScrollD[5] && this.current < config.scenesScrollD[6]) { // 场景六内减速
            this.speedChangeTo(0.00007)
          } else if (this.current > config.scenesScrollD[6] && this.current < config.scenesScrollD[6] + config.scenesScrollT[6] * 0.5) { // 场景七内减速
            this.speedChangeTo(0.00007)
          } else if (this.current > config.scenesScrollD[6] + config.scenesScrollT[6] * 0.5 && this.current < config.scenesScrollD[7]) { // 场景七内减速
            this.speedChangeTo(0.00004)
          } else {
            this.speedChangeTo(0.0001)
          }
          this.current += this.speed * d / 10
          if (this.current < 1) {
            this.moveTo(-this.current * config.totalScrollW)
            this.play()
            this.showBtnImg = false
          } else {
            this.showBtn = false
            this.stop(true)
            this.showBtnImg = false
          }
        }, 10)
      }
    },

    speedChangeTo (target) {
      if (this.speed !== target && !this.speedTimeout) {
        this.speedChange(target)
      }
    },

    speedChange (target) {
      this.speedTimeout = setTimeout(() => {
        this.speed += 0.000001 * (this.speed - target > 0 ? -1 : 1)
        if (Math.abs(this.speed - target) < 0.00001) {
          this.speed = target
          clearTimeout(this.speedTimeout)
          this.speedTimeout = null
        } else {
          this.speedChange(target)
        }
      }, 10)
    },

    stop (force) {
      if (force || this.current < 0.9) {
        this.lastTmp = 0
        this.showBtnImg = true
        clearTimeout(this.playTimeout)
        this.playTimeout = null
      }
    }
  },

  mounted () {
    this.init()
    window.app = this
  }
}
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';

@keyframes opening {
  0% {
    // transform: translate(315%, 120%) scale(8, 8);
    transform: translate(150%, 100%) scale(4, 4);
    animation-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  }
  50% {
    // transform: translate(315%, -70%) scale(8, 8);
    transform: translate(150%, -20%) scale(4, 4);
    animation-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  }
  100% {
    transform: translate(0, 0) scale(1, 1);
  }
}

.opening {
  animation-name: opening;
  animation-duration: 5s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
}

.home {
  @include fullscreen;
  @include bg-cover;
  background-image: url('http://cdn.shikehuyu.com/yfjs/scene1/sky.png');
  overflow: hidden;
  font-size: 0;
  canvas {
    width: 100%;
    height: 100%;
    // 测试时注释掉
    // transform: translate(315%, 120%) scale(8, 8);
    transform: translate(150%, 100%) scale(4, 4);
  }
  &__share {
    @include fullscreen;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.5);
    &__img {
      position: absolute;
      top: .1rem;
      right: .2rem;
      width: 40vw;
    }
  }
  &__btn {
    @include fullscreen;
    z-index: 100;
    user-select: none;
    &__img {
      @include bg-contain;
      background-image: url('http://cdn.shikehuyu.com/yfjs/public/hint.png');
      position: absolute;
      width: 26vw;
      height: 30vw;
      bottom: 3%;
      left: 37vw;
      transition: opacity ease .5s;
      opacity: 0;
      &.show {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue